export default {
  en: {
    download: 'DOWNLOAD',
    print: 'PRINT',
    saveDraft: 'SAVE DRAFT',
    saveContract: 'PUBLISH',
    close: 'CLOSE'
  },
  th: {
    download: 'ดาวน์โหลด',
    print: 'พิมพ์',
    saveDraft: 'บันทึกโครงร่าง',
    saveContract: 'เผยแพร่',
    close: 'ปิด'
  }
}
